import { camelizeKeys } from 'humps'
import jwtDefaultConfig from './jwt/jwtDefaultConfig'

const isUserLoggedIn = () => {
  return (
    localStorage.getItem(jwtDefaultConfig.storageUserDataKeyName) &&
    localStorage.getItem(jwtDefaultConfig.storageTokenKeyName)
  )
}

const getUserData = () =>
  camelizeKeys(
    JSON.parse(localStorage.getItem(jwtDefaultConfig.storageUserDataKeyName))
  ) || {}

const AUTH_ROUTE_NAMES = new Set([
  'account-login',
  'forgot-password',
  'reset-password',
])

const isValidRedirectPath = (path) =>
  typeof path === 'string' && path.startsWith('/') && !path.startsWith('//')

const getLoginRedirectQuery = (route) => {
  if (AUTH_ROUTE_NAMES.has(route.name)) {
    return {}
  }

  const { fullPath } = route
  return isValidRedirectPath(fullPath) ? { redirect: fullPath } : {}
}

const getPostLoginRedirect = (route) => {
  const redirect = route.query.redirect
  if (isValidRedirectPath(redirect)) {
    return redirect
  }
  return { name: 'home' }
}

export {
  isUserLoggedIn,
  getUserData,
  getLoginRedirectQuery,
  getPostLoginRedirect,
}
